/**
 * Ćirilica -> latinica transliteracija za nazive artikala iz JSON izvoza
 * Poreske uprave (Izveštaji -> Poreska uprava -> MiniMax) - vidi razgovor
 * "posto je cirilicom sve se lose vidi". Portal Poreske uprave šalje nazive
 * ćirilicom, a ostatak Finora ekrana je na latinici - radi čitljivosti u
 * tabelama se ćirilica prikazuje transliterovana na latinicu. Ovo NE menja
 * podatke koji se čuvaju u bazi ili šalju u XLSX - samo kako se prikazuju
 * na ekranu u ovom izveštaju.
 *
 * Digrafi (Љ/Њ/Џ) se moraju obraditi PRE pojedinačnih ćiriličnih slova.
 */
const DIGRAPHS: [string, string][] = [
  ["Љ", "Lj"],
  ["љ", "lj"],
  ["Њ", "Nj"],
  ["њ", "nj"],
  ["Џ", "Dž"],
  ["џ", "dž"],
];

const SINGLE: Record<string, string> = {
  А: "A", а: "a",
  Б: "B", б: "b",
  В: "V", в: "v",
  Г: "G", г: "g",
  Д: "D", д: "d",
  Ђ: "Đ", ђ: "đ",
  Е: "E", е: "e",
  Ж: "Ž", ж: "ž",
  З: "Z", з: "z",
  И: "I", и: "i",
  Ј: "J", ј: "j",
  К: "K", к: "k",
  Л: "L", л: "l",
  М: "M", м: "m",
  Н: "N", н: "n",
  О: "O", о: "o",
  П: "P", п: "p",
  Р: "R", р: "r",
  С: "S", с: "s",
  Т: "T", т: "t",
  Ћ: "Ć", ћ: "ć",
  У: "U", у: "u",
  Ф: "F", ф: "f",
  Х: "H", х: "h",
  Ц: "C", ц: "c",
  Ч: "Č", ч: "č",
  Ш: "Š", ш: "š",
};

const CYRILLIC_RANGE = /[Ѐ-ӿ]/;

/** true ako tekst sadrži bar jedno ćirilično slovo (Poreska uprava meša skripte u istom nazivu). */
export function hasCyrillic(text: string): boolean {
  return CYRILLIC_RANGE.test(text);
}

export function cyrillicToLatin(text: string): string {
  if (!text || !hasCyrillic(text)) return text;
  let result = text;
  for (const [cyr, lat] of DIGRAPHS) {
    result = result.split(cyr).join(lat);
  }
  return result.replace(/[Ѐ-ӿ]/g, (ch) => SINGLE[ch] ?? ch);
}
